import React, { useEffect, useRef, useState, useId } from 'react'
import PropTypes from 'prop-types'
import { Button, TextAreaInput, TextInput } from 'components/ui'
import CongratsBanner from '../congratsBanner/congratsBanner'
import ConfirmV2 from '../confirmV2/confirmV2'
import DialogAction from '../dialogAction/dialogAction'
import MetaDataInputV2 from '../common/metaDataInputV2/metaDataInputV2'
import TagInputV2 from '../common/tagInputV2/tagInputV2'
import BelongBuilding from '../belongBuilding/belongBuilding'
import BusinessHourInputV3 from '../businessHourInputV3/businessHourInputV3'
import Collapse from '../collapse/collapse'
import PhotosInputV2 from '../photosInputV2/photosInputV2'
import LocationInputV2 from '../common/locationInputV2/locationInputV2'
import Subcategory from '../subcategory/subcategory'
import MainCategory from '../mainCategory/mainCategory'
import DialogBody from '../dialogBody/dialogBody'
import DialogHeader from '../dialogHeader/dialogHeader'
import Dialog from '../dialog/dialog'
import { ApiTool, AppTool, PlaceTool, UrlTool } from '../../tool'
import { Resource } from '../../resource'
import { AlertTypeEnum, CodeEnum } from '../../enum'
import { ImageConfig, LinkIconConfig, RouterConfig, UrlConfig } from '../../config'
import { useHistory } from 'react-router-dom'
import { useForm, useQuery } from '../../useHooks'
import * as yup from 'yup'
import './boundaryRequestUpdate.scss'
import AddressInputV2 from '../addressInputV2/addressInputV2'

const MAX_LENGTH_NAME = 256
const MAX_LENGTH_DESCRIPTION = 1000
const MAX_SIZE_FILE = 10485760 //convert 10MB to Bytes
const MAX_TOTAL_SIZE_FILES = 104857600 //convert 100MB to Bytes
const ACCEPT_FILES = '.png, .jpg, .jpeg, .webp , .svg'
const REGEX_WEBSITE = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/

const BoundaryRequestUpdate = () => {
  const history = useHistory()
  const FORM_ID = useId()
  const { id } = useQuery()

  const apiSubmitRef = useRef()
  const apiUploadRef = useRef()
  const timeOutRef = useRef()
  const detailPoiRef = useRef()

  const [showConfirm, setShowConfirm] = useState(false)
  const [showOtherInfo, setShowOtherInfo] = useState(false)
  const [poi, setPoi] = useState(null)
  const [showBanner, setShowBanner] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [name, setName] = useState('')
  const [isChange, setIsChange] = useState(false)

  const schema = yup.object().shape({
    name: yup.string().required(
      Resource.formatString(Resource.validate.required, {
        field: Resource.common.name
      })
    ),

    address: yup.string().required(
      Resource.formatString(Resource.validate.required, {
        field: Resource.common.address
      })
    ),

    website: yup
      .string()
      .test(
        'websiteFormat',
        Resource.formatString(Resource.validate.format, { field: Resource.common.website }),
        function (website) {
          if (website && !REGEX_WEBSITE.test(website)) {
            return false
          }
          return true
        }
      ),

    mediaFiles: yup
      .mixed()
      .nullable()
      .test(
        'formatFile',
        Resource.formatString(Resource.validate.formatImage, { format: ACCEPT_FILES }),
        function (mediaFiles) {
          let check = true
          let format = ['png', 'jpg', 'jpeg', 'webp', 'svg']
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              let typeFile = file?.name?.split('.')?.pop()
              if (!format.includes(typeFile?.toLowerCase())) {
                check = false
              }
            })
          }
          return check
        }
      )
      .test(
        'sizeFile',
        Resource.formatString(Resource.validate.maxCapacityImage, { numberUnit: '10MB' }),
        function (mediaFiles) {
          let check = true
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              if (file.size > MAX_SIZE_FILE) {
                check = false
              }
            })
          }
          return check
        }
      )
      .test(
        'totalSizeFile',
        Resource.formatString(Resource.validate.maxTotalCapacityImage, { numberUnit: '100MB' }),
        function (mediaFiles) {
          let check = true
          let countSize = 0
          if (mediaFiles?.length > 0) {
            mediaFiles?.forEach((file) => {
              countSize += file?.size
            })
            if (countSize > MAX_TOTAL_SIZE_FILES) {
              check = false
            }
          }
          return check
        }
      )
  })

  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
    isRequiredError
  } = useForm({
    resolver: schema
  })

  useEffect(() => {
    var sourcePlace
    if (id) {
      sourcePlace = ApiTool.get(
        UrlConfig.poi.detail.replace('{id}', id),
        (res) => {
          if (res?.code == CodeEnum.ok) {
            let placeNew = res?.result
            let isArea = PlaceTool.isArea(placeNew)
            if (!isArea) {
              history.push({
                pathname: RouterConfig.home
              })
            }
            detailPoiRef.current = { ...res?.result } || {}
            setPoi(placeNew)
            setName(placeNew?.name || '')
            setValue('name', placeNew?.name)
            setValue('address', placeNew?.address)
            setValue('website', placeNew?.website || '')
            setValue('description', placeNew?.description || '')
          } else {
            setPlace(null)
          }
        },
        true
      )
    }
    return () => {
      sourcePlace?.cancel()
    }
  }, [id])

  useEffect(() => {
    let poiTrimText = {
      ...poi,
      name: poi?.name?.trim(),
      address: poi?.address?.trim(),
      website: poi?.website?.trim(),
      description: poi?.description?.trim()
    }
    let dataUpdate = PlaceTool.createRequestPoiV4(detailPoiRef?.current, poiTrimText)
    let check = Object?.keys(dataUpdate)?.length > 0 || poi?.imageFiles?.length > 0
    setIsChange(check)
  }, [poi])

  const onCloseDialog = () => {
    setShowConfirm(true)
  }

  const onConfirmClose = () => {
    history.push({
      pathname: location.pathname,
      search: UrlTool.createSearch({ ep: undefined, typeGeometry: undefined, id: undefined }, { extendOldQuery: true })
    })
    setPoi(null)
  }

  const onCloseConfirm = () => {
    setShowConfirm(false)
  }

  const onClickOtherInfo = () => {
    setShowOtherInfo((prev) => !prev)
  }

  const onChangeName = (e) => {
    let value = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        name: value
      }
    })
    setValue('name', value, { shouldValidate: formState.isSubmitted })
  }

  const onChangeAddress = (value) => {
    let valueAddress = value?.address || value || ''
    setPoi((prev) => {
      return {
        ...prev,
        address: valueAddress
      }
    })
    setValue('address', valueAddress, { shouldValidate: formState.isSubmitted })
  }

  const onChangeLocation = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        location: value
      }
    })
  }

  const onChangeMediaFile = (mediaFiles, imageFiles) => {
    setPoi((prev) => {
      return {
        ...prev,
        mediaFiles: mediaFiles,
        imageFiles: imageFiles
      }
    })
    setValue('mediaFiles', imageFiles, { shouldValidate: formState.isSubmitted })
  }

  const onChangeWebsite = (e) => {
    let valueWebsite = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        website: valueWebsite?.trim()
      }
    })
    setValue('website', valueWebsite, { shouldValidate: formState.isSubmitted })
  }

  const onChangeDescription = (e) => {
    let valueDescription = e?.target.value || ''
    setPoi((prev) => {
      return {
        ...prev,
        description: valueDescription
      }
    })
  }

  const onChangeMetaData = (value) => {
    setPoi((prev) => {
      return {
        ...prev,
        metadata: value
      }
    })
  }

  const createPoi = (data) => {
    let requestData = PlaceTool.createRequestPoiV4(detailPoiRef.current, data)
    let body = {
      ...requestData,
      placeId: id
    }
    apiSubmitRef?.current?.cancel()
    apiSubmitRef.current = ApiTool.post(
      UrlConfig.boundaryEdit.create,
      body,
      (res) => {
        setLoadingSubmit(false)
        if (res?.code == CodeEnum.ok) {
          setShowBanner(true)
        } else {
          AppTool.alert(
            res?.message ||
              Resource.formatString(Resource.alert.error.requestUpdate, {
                object: Resource.common.place.toLowerCase()
              }),
            AlertTypeEnum.error
          )
        }
      },
      true
    )
  }

  const onSubmit = (data) => {
    let imageFiles = data?.mediaFiles
    setLoadingSubmit(true)
    timeOutRef?.current && clearTimeout(timeOutRef?.current)
    timeOutRef.current = setTimeout(() => {
      if (imageFiles?.length > 0) {
        let body = {
          files: imageFiles
        }
        apiUploadRef?.current?.cancel()
        apiUploadRef.current = ApiTool.postFormFromJson(
          UrlConfig.file.listMedia,
          body,
          (res) => {
            if (res?.code == CodeEnum.ok) {
              let data = {
                ...(poi || {})
              }
              data.mediaFiles = poi?.mediaFiles?.concat(res?.result)
              createPoi(data)
            } else {
              AppTool.alert(
                res?.message ||
                  Resource.formatString(Resource.alert.error.add, {
                    object: Resource.common.images.toLowerCase()
                  }),
                AlertTypeEnum.error
              )
            }
          },
          true
        )
      } else {
        createPoi(poi)
      }
    }, 300)
  }

  const onCloseBanner = () => {
    setShowBanner(false)
    onConfirmClose()
  }

  return (
    <>
      <Dialog className='boundaryRequestUpdateCpn' onClose={onCloseDialog} open={true} disableCloseOnClickBackdrop>
        <DialogHeader subtitle={name || ''}>{Resource.updatePlace.requestUpdateBoundaries}</DialogHeader>

        <DialogBody>
          <form className='bodyDialog test' id={FORM_ID} noValidate onSubmit={handleSubmit(onSubmit)}>
            <div className='description'>
              <div className='title'>{Resource.boundary.infoAboutBoundary}</div>
              <div className='caption'>{Resource.boundary.captionInfoBoundary}</div>
            </div>

            <div className='mainInfo'>
              <TextInput
                inputRef={register({ name: 'name' })}
                required
                label={Resource.common.name}
                placeholder={Resource.name.add}
                maxLength={MAX_LENGTH_NAME}
                showCount
                value={poi?.name || ''}
                onChange={onChangeName}
                error={errors?.name ? true : false}
                helperText={errors?.name?.message}
              />

              <AddressInputV2
                required
                inputRef={register({ name: 'address' })}
                label={Resource.common.address}
                placeholder={Resource.address.add}
                value={poi?.address || ''}
                onChange={onChangeAddress}
                error={errors?.address ? true : false}
                helperText={errors?.address?.message}
                position={poi?.location}
              />

              <LocationInputV2
                value={poi?.location}
                onChange={onChangeLocation}
                isShowControl
                canFullScreen
                isShowMapType
                geometry={poi?.geometry}
              />
            </div>

            <div className='image'>
              <h4 className='title'>{Resource.boundary.photo}</h4>
              <div className='description'>{Resource.boundary.addPhoto}</div>
              <PhotosInputV2
                inputRef={register({ name: 'mediaFiles' })}
                value={poi?.mediaFiles}
                onChange={onChangeMediaFile}
                error={errors?.mediaFiles ? true : false}
                helperText={errors?.mediaFiles?.message}
                accept={ACCEPT_FILES}
              />
            </div>

            <div className='otherInfo' onClick={onClickOtherInfo}>
              <div className='head'>
                <div className='title'>{Resource.boundary.addOtherInfo}</div>
                <div className='toggle'>
                  {showOtherInfo ? (
                    <img src={LinkIconConfig.common.arrTop} alt='arrTop' />
                  ) : (
                    <img src={LinkIconConfig.common.arrBottom} alt='arrBottom' />
                  )}
                </div>
              </div>
              <div className='description'>{Resource.boundary.addOtherInfoBoundaryCaption}</div>
            </div>

            <Collapse open={showOtherInfo}>
              <div className='otherInfoContent'>
                <TextInput
                  inputRef={register({ name: 'website' })}
                  label={Resource.common.website}
                  placeholder={Resource.website.add}
                  value={poi?.website || ''}
                  onChange={onChangeWebsite}
                  error={errors?.website ? true : false}
                  helperText={errors?.website?.message}
                />

                <MetaDataInputV2 value={poi?.metadata} onChange={onChangeMetaData} />

                <TextAreaInput
                  label={Resource.common.description}
                  placeholder={Resource.description.add}
                  value={poi?.description || ''}
                  onChange={onChangeDescription}
                  maxLength={MAX_LENGTH_DESCRIPTION}
                  showCount
                />
              </div>
            </Collapse>
          </form>
        </DialogBody>

        <DialogAction>
          <Button onClick={onCloseDialog} variant='cancel'>
            {Resource.common.cancel}
          </Button>

          <Button
            style={{
              marginLeft: '0.75rem'
            }}
            variant='send'
            type='submit'
            form={FORM_ID}
            loading={loadingSubmit}
            disabled={loadingSubmit || isRequiredError || !isChange}
          >
            {Resource.common.send}
          </Button>
        </DialogAction>
      </Dialog>

      <ConfirmV2
        type='warning'
        open={showConfirm}
        message={Resource.confirmMessage.cancelRequestUpdatePlace}
        onConfirm={onConfirmClose}
        onClose={onCloseConfirm}
      />

      <CongratsBanner
        type='info'
        title={Resource.messageBanner.thankForImproving}
        subTitle={Resource.messageBanner.updateStatusRequest}
        open={showBanner}
        icon={<img src={ImageConfig.banner.likeHand} alt='likeHand' />}
        action={
          <Button variant='close' onClick={onCloseBanner}>
            {Resource.button.done.toLocaleUpperCase()}
          </Button>
        }
        onClose={onCloseBanner}
      />
    </>
  )
}

BoundaryRequestUpdate.propTypes = {
  //
}

export default BoundaryRequestUpdate
